define('BluePoint.SegregateItems.SegregateItems'
,   [
		'BluePoint.SegregateItems.SegregateItems.View'
	,	'SC.Configuration'
	,   'Backbone'
	,	'underscore'
	]
,   function (
		SegregateItemsView
	,	Configuration
	,   Backbone
	,	_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var item = false;
			var environment = container.getComponent("Environment");
			var isUsWebsite = environment.getConfig('registrationstate.isactive');
            var customer = container.getComponent('UserProfile');

			if (customer) {
                customer.getUserProfile().then(function (profile) {

                    var salesRepInfoField = profile.customfields.find(function (field) {
                        return field.id === 'custentity407';
                    });

                    var salesRepInfo = salesRepInfoField ? salesRepInfoField.value : false;
					var customerLoggedIn = profile.isloggedin;

					if (customerLoggedIn && salesRepInfo) {
						var excludedFacet = 'custitem_not_sales_item';
						
						_.extend(Configuration.searchApiMasterOptions.Facets, {
							'facet.exclude': excludedFacet, 'custitem_not_sales_item': item
						});
					
						_.extend(Configuration.searchApiMasterOptions.itemsSearcher, {
							'facet.exclude': excludedFacet, 'custitem_not_sales_item': item
						});
					
						_.extend(Configuration.searchApiMasterOptions.typeAhead, {
							'facet.exclude': excludedFacet, 'custitem_not_sales_item': item
						});
					
						_.extend(Configuration.searchApiMasterOptions.relatedItems, {
							'facet.exclude': excludedFacet, 'custitem_not_sales_item': item
						});
					
						_.extend(Configuration.searchApiMasterOptions.correlatedItems, {
							'facet.exclude': excludedFacet, 'custitem_not_sales_item': item
						});
					
						_.extend(Configuration.searchApiMasterOptions.itemDetails, {
							'facet.exclude': excludedFacet, 'custitem_not_sales_item': item
						});
					} else {
						if (isUsWebsite) {
							var excludedFacet = 'custitem_not_us_item';
						
							_.extend(Configuration.searchApiMasterOptions.Facets, {
								'facet.exclude': excludedFacet, 'custitem_not_us_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.itemsSearcher, {
								'facet.exclude': excludedFacet, 'custitem_not_us_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.typeAhead, {
								'facet.exclude': excludedFacet, 'custitem_not_us_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.relatedItems, {
								'facet.exclude': excludedFacet, 'custitem_not_us_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.correlatedItems, {
								'facet.exclude': excludedFacet, 'custitem_not_us_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.itemDetails, {
								'facet.exclude': excludedFacet, 'custitem_not_us_item': item
							});
						}
					
						if (!isUsWebsite) {
							var excludedFacet = 'custitem_not_ca_item';
						
							_.extend(Configuration.searchApiMasterOptions.Facets, {
								'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.itemsSearcher, {
								'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.typeAhead, {
								'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.relatedItems, {
								'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.correlatedItems, {
								'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
							});
						
							_.extend(Configuration.searchApiMasterOptions.itemDetails, {
								'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
							});
						}
					

						var plp = container.getComponent('PLP');
						if (plp) {
							plp.on('beforeShowContent', function () {
            			    	var itemsInfo = plp.getItemsInfo();
							
								if (itemsInfo) {
									var count = 0;
									_.each(itemsInfo, function (item) {
										var isAvailableInUSA = item.custitem_is_available_in_usa;
            						    var isAvailableInCanada = item.custitem_is_available_in_canada;
            						    var internalid = item.internalid;
										count++;

            						    if ((isUsWebsite && isAvailableInUSA === false) ||
            						        (!isUsWebsite && isAvailableInCanada === false))
            						    {
											count--;
											(function () {
    											function hideItem() {
    											    document
    											        .querySelectorAll('[data-item-id="'+internalid+'"]')
    											        .forEach(function (el) {
    											            var wrapper = el.closest('.facets-items-collection-view-cell-span3');
    											            if (wrapper) wrapper.style.display = 'none';
    											        });
    											}
											
    											hideItem();
											
    											new MutationObserver(hideItem).observe(document.body, {
    											    childList: true,
    											    subtree: true
    											});
											})();
            						    }
        							});
									
									plp.on('afterShowContent', function () {
									    setTimeout(function () {
									        var title = document.querySelector('.facets-facet-browse-title');
									        if (title) {
									            title.setAttribute('data-quantity', count);
									            title.childNodes[0].nodeValue = count + ' Results for ';
									        }
									    }, 0);
									});
        						}	
            				});
						}

					
						var pdp = container.getComponent('PDP');
						if (pdp) {
							pdp.on('beforeShowContent', function () {
            			    	var itemInfo = pdp.getItemInfo();
							
            			    	if (itemInfo || itemInfo.item) {
            			    		var isAvailableInUSA = itemInfo.item.custitem_is_available_in_usa;
            			    		var isAvailableInCanada = itemInfo.item.custitem_is_available_in_canada;
								
            			    		if ((isUsWebsite && isAvailableInUSA === false) ||
            			    		    (!isUsWebsite && isAvailableInCanada === false))
            			    		{
            			    		    Backbone.history.navigate('not-found', { trigger: true });
            			    		    return jQuery.Deferred().reject();
            			    		}
            			    	}
            				});
						}
					
					
						var cart = container.getComponent('Cart');
						if (cart) {
							cart.on('beforeAddLine', function (line) {
            			    	var item = line.item;
							
            			    	if (item) {
            			    		var isAvailableInUSA = item.custitem_is_available_in_usa;
            			    		var isAvailableInCanada = item.custitem_is_available_in_canada;
								
            			    		if ((isUsWebsite && isAvailableInUSA === false) ||
            			    		    (!isUsWebsite && isAvailableInCanada === false))
            			    		{
            			    		    var error = new Error('This item is not available on this site.');
            			    		    error.status = 403;
            			    		    throw error;
            			    		}
            			    	}
            				});
						}
					}
                });
			} else {
				if (isUsWebsite) {
					var excludedFacet = 'custitem_not_us_item';

					_.extend(Configuration.searchApiMasterOptions.Facets, {
						'facet.exclude': excludedFacet, 'custitem_not_us_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.itemsSearcher, {
						'facet.exclude': excludedFacet, 'custitem_not_us_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.typeAhead, {
						'facet.exclude': excludedFacet, 'custitem_not_us_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.relatedItems, {
						'facet.exclude': excludedFacet, 'custitem_not_us_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.correlatedItems, {
						'facet.exclude': excludedFacet, 'custitem_not_us_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.itemDetails, {
						'facet.exclude': excludedFacet, 'custitem_not_us_item': item
					});
				}

				if (!isUsWebsite) {
					var excludedFacet = 'custitem_not_ca_item';

					_.extend(Configuration.searchApiMasterOptions.Facets, {
						'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.itemsSearcher, {
						'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.typeAhead, {
						'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.relatedItems, {
						'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.correlatedItems, {
						'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
					});

					_.extend(Configuration.searchApiMasterOptions.itemDetails, {
						'facet.exclude': excludedFacet, 'custitem_not_ca_item': item
					});
				}


				var plp = container.getComponent('PLP');
				if (plp) {
					plp.on('beforeShowContent', function () {
            	    	var itemsInfo = plp.getItemsInfo();

						if (itemsInfo) {
							var count = 0;
							_.each(itemsInfo, function (item) {
								var isAvailableInUSA = item.custitem_is_available_in_usa;
            				    var isAvailableInCanada = item.custitem_is_available_in_canada;
            				    var internalid = item.internalid;
								count++;

            				    if ((isUsWebsite && isAvailableInUSA === false) ||
            				        (!isUsWebsite && isAvailableInCanada === false))
            				    {
									count--;
									(function () {
    									function hideItem() {
    									    document
    									        .querySelectorAll('[data-item-id="'+internalid+'"]')
    									        .forEach(function (el) {
    									            var wrapper = el.closest('.facets-items-collection-view-cell-span3');
    									            if (wrapper) wrapper.style.display = 'none';
    									        });
    									}

    									hideItem();

    									new MutationObserver(hideItem).observe(document.body, {
    									    childList: true,
    									    subtree: true
    									});
									})();
            				    }
        					});

							plp.on('afterShowContent', function () {
								setTimeout(function () {
								    var title = document.querySelector('.facets-facet-browse-title');
								    if (title) {
								        title.setAttribute('data-quantity', count);
								        title.childNodes[0].nodeValue = count + ' Results for ';
								    }
								}, 0);
							});
        				}	
            		});
				}


				var pdp = container.getComponent('PDP');
				if (pdp) {
					pdp.on('beforeShowContent', function () {
            	    	var itemInfo = pdp.getItemInfo();

            	    	if (itemInfo || itemInfo.item) {
            	    		var isAvailableInUSA = itemInfo.item.custitem_is_available_in_usa;
            	    		var isAvailableInCanada = itemInfo.item.custitem_is_available_in_canada;

            	    		if ((isUsWebsite && isAvailableInUSA === false) ||
            	    		    (!isUsWebsite && isAvailableInCanada === false))
            	    		{
            	    		    Backbone.history.navigate('not-found', { trigger: true });
            	    		    return jQuery.Deferred().reject();
            	    		}
            	    	}
            		});
				}


				var cart = container.getComponent('Cart');
				if (cart) {
					cart.on('beforeAddLine', function (line) {
            	    	var item = line.item;

            	    	if (item) {
            	    		var isAvailableInUSA = item.custitem_is_available_in_usa;
            	    		var isAvailableInCanada = item.custitem_is_available_in_canada;

            	    		if ((isUsWebsite && isAvailableInUSA === false) ||
            	    		    (!isUsWebsite && isAvailableInCanada === false))
            	    		{
            	    		    var error = new Error('This item is not available on this site.');
            	    		    error.status = 403;
            	    		    throw error;
            	    		}
            	    	}
            		});
				}
			}
		}
	};
});
